import style from "./style.scss";
import Link from "../link";
import Navigation from "./navigation";
import { mergeClasses } from "../helpers";
import namedRoutes from "../../settings/routes";

const Header = () => (
  <header class={mergeClasses([style.header, "dark"])}>
    <div class={style.wrapper}>
      <div class={style.brand}>
        <Link href={namedRoutes.home} aria-label="Tyson's Gear Lab">
          <img
            src="/icons/logo-text.svg"
            alt="Tyson's Gear Lab"
            itemprop="logo"
          />
        </Link>
      </div>
      <div class={style.navigation}>
        <Navigation />
      </div>
    </div>
  </header>
);

export default Header;
